import React from 'react';
import PropTypes from 'prop-types';
import * as Translations from '../../providers/i18n';
import './style.scss';

function CollborationGroupError({ i18n }) {
    return (
        <div className="collaboration-group-error-wrapper">
            <div className="text">
                <h3>{i18n.t('attachments_preview.collaboration.comments.group_error.title')}</h3>
                <p>{i18n.t('attachments_preview.collaboration.comments.group_error.text')}</p>
            </div>
        </div>
    );
}

CollborationGroupError.propTypes = {
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export default Translations.connect(CollborationGroupError);
